<div class="requisitos-senha">
  <span class="texto-inter requisitos-senha__titulo">{{ titulo }}</span>
  <ul class="requisitos-senha__lista ps-0 mb-0">
    <li *ngFor="let rs of requisitos"
        class="requisitos-senha__item d-flex align-items-center"
        [class.requisitos-senha__item--ok]="rs.valid">
      <span class="requisitos-senha__icone" [class.requisitos-senha__icone--ok]="rs.valid" aria-hidden="true">
        <span class="material-symbols-outlined">{{ rs.valid ? 'check_circle' : 'radio_button_unchecked' }}</span>
      </span>
      <span class="requisitos-senha__texto texto-inter">{{ rs.label }}</span>
    </li>
  </ul>
</div>

